import classNames from 'classnames';
import React from 'react';
import IconButton from './IconButton';
import * as styles from './ReorderableListRow.module.scss';
import SVGIcon from './SVGIcon';
import clearIcon from '../icons/non-prefilled/16x16/clear.svg';
import dragIcon from '../icons/non-prefilled/16x16/drag.svg';

export type BasicReorderableItem = { id: string };

interface ReorderableRowProps<T> {
  item: T;
  isDragging: boolean;
  index: number;
  allowRemove: boolean;
  onRemove?: (index: number) => void;
  renderItem: (item: T, index: number) => JSX.Element;
}

const ReorderableListRow = <T extends BasicReorderableItem>({
  item,
  isDragging,
  index,
  allowRemove,
  onRemove,
  renderItem,
}: ReorderableRowProps<T>) => {
  return (
    <div
      className={classNames(styles.row, {
        [styles.isDragging]: isDragging,
      })}
    >
      <div className={styles.dragIconContainer}>
        <SVGIcon className={styles.dragIcon} size="small">
          {dragIcon}
        </SVGIcon>
      </div>
      {renderItem(item, index)}
      {allowRemove && onRemove && (
        <IconButton
          className={styles.deleteButton}
          onClick={() => onRemove(index)}
          size="small"
          aria-label="Remove"
        >
          {clearIcon}
        </IconButton>
      )}
    </div>
  );
};

export default ReorderableListRow;
